// import React from 'react'
import { Link, useLocation } from "react-router-dom";
import { MdShoppingBasket } from "react-icons/md";
import { motion } from "framer-motion";
import { useStateValue } from "../../context/StateProvider";
import { useEffect } from "react";

const Navigations = ({ direction }: { direction?: string }) => {
  const [{ showContactForm, cartItems }, dispatch] = useStateValue();
  const location = useLocation();

  const handleToggleCart = () => {
    dispatch({
      type: "TOGGLE_CART",
      showCart: true,
    });
  };

  const handleToggleContact = () => {
    dispatch({
      type: "TOGGLE_CONTACT_FORM",
      showContactForm: !showContactForm,
    });
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };
  return (
    <div className="flex items-center gap-8">
      <motion.ul
        initial={{ opacity: 0, x: 200 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: 200 }}
        className={`flex items-center gap-8 ${direction && direction}`}
      >
        <motion.li
          whileHover={{ scale: 1.1 }}
          className={`md:text-sm lg:text-md text-base cursor-pointer duration-100 transition-all ease-in-out ${
            isActive("/")
              ? "text-[#227a32] font-bold"
              : "text-textColor hover:text-[#ac9430]"
          }`}
        >
          <Link to={"/"}>Home</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.1 }}
          className={`md:text-sm lg:text-md text-base cursor-pointer duration-100 transition-all ease-in-out ${
            isActive("/menu")
              ? "text-[#227a32] font-bold"
              : "text-textColor hover:text-[#ac9430]"
          }`}
        >
          <Link to={"/menu"}>Menu</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.1 }}
          className={`md:text-sm lg:text-md text-base cursor-pointer duration-100 transition-all ease-in-out ${
            isActive("/services")
              ? "text-[#227a32] font-bold"
              : "text-textColor hover:text-[#ac9430]"
          }`}
        >
          <Link to={"/services"}>Services</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.1 }}
          className={`md:text-sm lg:text-md text-base cursor-pointer duration-100 transition-all ease-in-out ${
            isActive("/about")
              ? "text-[#227a32] font-bold"
              : "text-textColor hover:text-[#ac9430]"
          }`}
        >
          <Link to={"/about"}>About us</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.1 }}
          className={`md:text-sm lg:text-md text-base cursor-pointer duration-100 transition-all ease-in-out ${
            isActive("/catering")
              ? "text-[#227a32] font-bold"
              : "text-textColor hover:text-[#ac9430]"
          }`}
        >
          <Link to={"/catering"}>Catering</Link>
        </motion.li>
        <motion.li
          whileHover={{ scale: 1.1 }}
          className={`md:text-sm lg:text-md text-base cursor-pointer duration-100 transition-all ease-in-out ${
            isActive("/gallery")
              ? "text-[#227a32] font-bold"
              : "text-textColor hover:text-[#ac9430]"
          }`}
        >
          <Link to={"/gallery"}>Gallery</Link>
        </motion.li>
      </motion.ul>
    </div>
  );
};

export default Navigations;
